import { Button } from "@mui/material";
import {caseInsensitiveSort, sortIntegerValues} from "../common/Utils";
const selected=(data)=>{
	if(data)
	return "green"
	
	}

export const userEnrollmentAuditColumns = [
    {
		name: 'Log Id',
		selector: row => <div style={{overflow:"hidden",textOverflow:"ellipsis"}}>{row.id}</div>,
        sortable: true,
		minWidth:"100px",
		center: true,
		style: {
			justifyContent: "center",
			textAlign:"center",
			minWidth:"100px",
		},
		sortFunction: (rowA, rowB) => sortIntegerValues(rowA, rowB, (row) => row.id? row.id:""),
		//width:"150px"
	},
	{
		name: 'Enrollment Id',
		selector: row => <div style={{overflow:"hidden",textOverflow:"ellipsis"}}>{row.enrollmentId}</div>,
        sortable: true,
		minWidth: "180px",
		center: true,
		style: {
			justifyContent: "center",
			textAlign:"center",
			minWidth:"180px",
		},
		sortFunction: (rowA, rowB) => sortIntegerValues(rowA, rowB, (row) => row.enrollmentId? row.enrollmentId:""),
	},
	{
		name: 'Updated By',
		selector: row => <div style={{overflow:"hidden",textOverflow:"ellipsis"}}>{row.updatedBY}</div>,
		sortable: true,
		minWidth:"280px",
		center: true,
		style: {
			justifyContent: "center",
			textAlign:"center",
			minWidth:"280px",
		},
		sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) => row.updatedBY? row.updatedBY :""),
	},
	{
		name: 'Updated At',
		selector: row => <div style={{overflow:"hidden",textOverflow:"ellipsis"}}>{row.updatedAt}</div>,
        sortable: true,
		center: true,
		minWidth:"250px",
		style: {
			justifyContent: "center",
			textAlign:"center",
			minWidth:"250px",
		},
		sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) => row.updatedAt? row.updatedAt :""),
	},
	{
		name: 'Action',
		selector: row => <div style={{overflow:"hidden",textOverflow:"ellipsis"}}>{row.action}</div>,
        sortable: true,
		center: true,
		minWidth:"180px",
		style: {
			justifyContent: "center",
			textAlign:"center",
			minWidth:"180px",
		},
		sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) => row.action? row.action :""),
	},
	{
		name: '',
		sortable:true,
		center: true,
		field:'action',	
		minWidth: "180px",
		style: {
			justifyContent: "center",
			textAlign:"center",
			minWidth:"180px",
		},
		cell: row => 
				<Button sx={{color:{selected}, textTransform:'unset !important', width:"120px",margin:"10px"}} 
				variant="outlined" row={row} data-tag="allowRowEvents" 
				> Select </Button>
	},
];

export const enrollmentAuditExcelColumns = [
    {
		header: 'Log Id',
		key: 'id',
	},
	{
		header: 'Enrollment Id',
		key: 'enrollmentId',
	},
	{
		header: 'Old Values',
		key: 'oldValues',
	},
	{
		header: 'New Values',
		key: 'newValues',
	},
	{
		header: 'Updated By',
		key: 'updatedBY',
	},
	{
		header: 'Updated At',
		key: 'updatedAt',
	},
	{
		header: 'Action',
		key: 'action',
	}
];


